import auth from './auth';
import checklists from './checklists';
import countries from './countries';
import regions from './regions';
import pppelements from './pppelements';
import infopages from './infopages';
import image from './image';
import statistics from './statistics';
import logs from './logs';
import notifications from './notifications';

export default {
    auth,
    checklists,
    countries,
    pppelements,
    infopages,
    image,
    statistics,
    logs,
    notifications,
    regions,
};
